module.exports = __webpack_public_path__ + "static/media/tech_news_100k.d276d04d.avif";